import {Navigate, Route, Routes} from "react-router-dom";
import Login from "../Pages/Auth/Login";
import {useEffect, useState} from "react";
import Register from "../Pages/Auth/Register";
import Cabinet from "../Pages/Cabinet/Cabinet";
import {API_URL} from "../URL";
import {useDispatch, useSelector} from "react-redux";
import {SET_USER} from "../store/constants";
import {BoardPage} from "../Pages/Board/BoardPage";
import {Header} from "../components/Header/Header";

export const AppRouter = () => {
    // const [user, setUser] = useState(null);
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(API_URL + "/me/", {
            credentials: "include",
        })
            .then(res => res.json())
            .then(data => {
                if (data.loggedIn) {
                    dispatch({ type: SET_USER, payload: data.user });
                } else {
                    dispatch({ type: SET_USER, payload: null });
                }
            })
            .catch(() => {
                dispatch({ type: SET_USER, payload: null });
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <Routes>
            <Route
                path="/login"
                element={user ? <Navigate to="/cabinet"/> : <Login/>}
            />

            <Route
                path="/register"
                element={user ? <Navigate to="/cabinet"/> : <Register/>}
            />

            <Route
                path="/cabinet"
                element={
                    user ? (
                        <>
                            <Header />
                            <Cabinet/>
                        </>
                    ) : <Navigate to="/login"/>
                }
            />

            <Route
                path="/board/:id"
                element={
                    user ? (
                        <>
                            <Header />
                            <BoardPage />
                        </>
                    ) : <Navigate to="/login"/>
                }
            />

            <Route
                path="/"
                element={<Navigate to={user ? "/cabinet" : "/login"}/>}
            />

            <Route
                path="*"
                element={<Navigate to={user ? "/cabinet" : "/login"}/>}
            />
        </Routes>
    );
};